import { LanguageCode } from '@/interfaces';

export enum PageType {
  LandingPage = 'LandingPage',
  TagPage = 'TagPage',
  MarketPage = 'MarketPage',
}

export enum RouteName {
  Home = 'Home',
  ArticleSummary = 'ArticleSummary',
  Article = 'Article',
  SignInWithLinkedIn = 'SignInWithLinkedIn',
  Verify = 'Verify',
  TrackMyParcelEn = 'TrackMyParcelEn',
  TrackMyParcelMultiLanguages = 'TrackMyParcelMultiLanguages',
  Carriers = 'Carriers',
  IndividualCarrier = 'IndividualCarrier',
  Market = 'Market',
  AccountEn = 'Account',
  AccountMultiLanguages = 'AccountMultiLanguages',
}

interface IRoute {
  path: string;
  component: any;
}

const ROUTES: Record<string, IRoute> = {
  [RouteName.Home]: {
    path: '/',
    component: async () => import('pages'),
  },
  [RouteName.ArticleSummary]: {
    path: '/[articleTypeSlug]',
    component: async () => import('pages/[articleTypeSlug]'),
  },
  [RouteName.Article]: {
    path: '/[articleTypeSlug]/[slug]',
    component: async () => import('pages/[articleTypeSlug]/[slug]'),
  },
  [RouteName.SignInWithLinkedIn]: {
    path: '/sign-in-with-linkedin',
    component: async () => import('pages/sign-in-with-linkedin'),
  },
  [RouteName.Verify]: {
    path: '/verify',
    component: async () => import('pages/verify'),
  },
  [RouteName.TrackMyParcelEn]: {
    path: '/track-my-parcel',
    component: async () => import('pages/track-my-parcel'),
  },
  [RouteName.TrackMyParcelMultiLanguages]: {
    path: '/[articleTypeSlug]/track-my-parcel',
    component: async () => import('pages/[articleTypeSlug]/track-my-parcel'),
  },
  [RouteName.Carriers]: {
    path: '/companies/[companyType]',
    component: async () => import('pages/companies/[companyType]'),
  },
  [RouteName.IndividualCarrier]: {
    path: '/companies/[companyType]/[slug]',
    component: async () => import('pages/companies/[companyType]/[slug]'),
  },
  [RouteName.Market]: {
    path: '/markets/[slug]',
    component: async () => import('pages/markets/[slug]'),
  },
  [RouteName.AccountEn]: {
    path: '/account',
    component: async () => import('pages/account'),
  },
  [RouteName.AccountMultiLanguages]: {
    path: '/[articleTypeSlug]/account',
    component: async () => import('pages/[articleTypeSlug]/account'),
  },
};

export enum ArticleTypeName {
  news = 'news',
  insights = 'insights',
  events = 'events',
  exclusives = 'exclusives',
  people = 'people',
  markets = 'markets',
  topic = 'topic',
  hub = 'hub',
  reports = 'reports',
}

export enum AmpPageType {
  country = 'country',
  carrier = 'carrier',
}

export enum SeoPageType {
  global = 'global',
  region = 'region',
  country = 'country',
  carrier = 'carrier',
}

export const SUPPORTED_LOCALES = [
  'zh',
  'nl',
  'en',
  'fr',
  'de',
  'el',
  'hi',
  'hu',
  'id',
  'it',
  'ja',
  'ko',
  'ms',
  'pl',
  'pt',
  'ro',
  'ru',
  'es',
  'ta',
  'th',
  'tr',
  'vi',
];

export enum CompanyType {
  carriers = 'carriers',
  merchants = 'merchants',
  retailers = 'retailers',
}

export const ACCEPTED_ARTICLE_TYPES: Record<string, string> = {
  [ArticleTypeName.news]: 'news',
  [ArticleTypeName.insights]: 'insights',
  [ArticleTypeName.events]: 'events',
  [ArticleTypeName.exclusives]: 'exclusives',
  [ArticleTypeName.people]: 'people',
  [ArticleTypeName.markets]: 'markets',
  [ArticleTypeName.topic]: 'topic',
  [ArticleTypeName.hub]: 'hub',
  [ArticleTypeName.reports]: 'reports',
  [AmpPageType.country]: 'country',
  [AmpPageType.carrier]: 'carrier',
};

const LANGUAGE_CODES_GROUP = Object.values(LanguageCode);

export const MULTI_LANGUAGE_PAGE_SLUGS = ['track-my-parcel', 'account', 'manage-email-subscriptions'];

export const MULTI_LANGUAGE_PAGES_REGEX = new RegExp(
  `^/((${LANGUAGE_CODES_GROUP.join('|')})/)?(${MULTI_LANGUAGE_PAGE_SLUGS.join('|')})$`,
);

export enum SlugRoutes {
  carriers = '/companies/carriers',
  companies = '/companies',
  markets = '/markets',
}

export enum PpSlugRoutes {
  insights = '/insights',
  resources = '/resources',
  reports = '/reports',
}

export default ROUTES;
